import bridge from 'libs/bridge';
import toast from 'components/common/toast';
import { compressImg } from './imgControll.js';

export interface IConfig {
    width: number;
    height: number;
    quality?: number;
}

const defaultConfig: IConfig = { quality: 100, width: 0, height: 0 };
/**
 * 预览图片时，使用高清无码大图
 * @param url 缩略图(原图)
 * @param config 配置
 * @return 高清图
 */
export function optimizeImg<T extends string>(url: T, config?: IConfig): T {
    return compressImg(url, { ...defaultConfig, ...config });
}

export const previewImgs = (images: string[], index: number) => {
    if (bridge.supports('gallery')) {
        bridge.call('gallery', {
            images: images.map((url) => optimizeImg(url)),
            index
        });
    } else {
        toast('您的设备不支持预览功能');
    }
};
